import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import { MenuCategory, MenuItem, MenuSection } from '../../models/FSMenu';
import { AppState } from '../../models/AppState';
import { combineLatest, Subscription } from 'rxjs';
import { ThemeService } from '../../services/theme-service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../services/order.service';
import { MenuService } from '../../services/menu.service';
import { ConfigService } from '../../services/config.service';
import { AppStateService } from '../../services/app-state.service';
import { MenuUtils } from '../../utils/Utils';
import { HiresDirective } from '../../directives/hires.directive';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { LoadingSpinnerComponent } from '../ui/loading-spinner-component';
import { OrderPageNavComponent } from '../ui/order-page-nav.component';
import { MenuItemComponent } from '../ui/menu-item.component';
import { ItemDetailComponent } from '../item-detail/item-detail.component';
import { BottomSheetService } from '../../services/bottom-sheet.service';
import { TranslateService } from '../../services/translate.service';

@Component({
  selector: 'app-menu-section',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    HiresDirective,
    CircleButtonComponent,
    LoadingSpinnerComponent,
    OrderPageNavComponent,
    MenuItemComponent,
    ItemDetailComponent
  ],
  templateUrl: './menu-section.component.html',
  styleUrl: './menu-section.component.css'
})
export class MenuSectionComponent implements OnInit, OnDestroy, AfterViewInit {
  section?: MenuSection;
  @ViewChild('contentDiv') contentDiv!: ElementRef;
  private isLoading = false;
  protected pageId: string | null = null;
  private sectionId: string | null = null;
  private appState: AppState | null = null;
  private sub?: Subscription;
  title?: string;
  icon?: string;
  categories?: MenuCategory[];
  topImage?: string;
  loading = false;
  showWhen = false;

  constructor(
    public themeService: ThemeService, private router: Router,
    private orderService: OrderService, private menuService: MenuService,
    private configService: ConfigService, private route: ActivatedRoute,
    private appStateService: AppStateService, private bottomSheetService: BottomSheetService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.beginObserving();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  ngAfterViewInit() {
    const topOffset = this.contentDiv.nativeElement.getBoundingClientRect().top;
    this.contentDiv.nativeElement.style.setProperty('--top-offset', `${topOffset}px`);
  }

  private beginObserving() {
    this.loading = true;
    this.sub = combineLatest([
      this.route.paramMap,
      this.appStateService.observeAppState(),
      this.menuService.observeAddendum(),
      this.translate.getTranslationsReceivedSubject()
    ]).subscribe(([pm, appState, addendum, t]) => { // "addendum" here is necessary for "out of stock" state to be updated
      this.isLoading = false;
      this.pageId = pm.get("page_id");
      this.sectionId = pm.get("section_id");
      this.appState = appState;
      this.loading = false;
      this.showWhen = appState.order?.user_cfg?.when_tag != null;

      this.section = MenuUtils.getSection(this.appState, this.pageId!, this.sectionId!);
      this.translate.sections([this.section]);
      if (this.section) {
        this.categories = this.filterCategories(this.section.categories);
        //this.topImage = "https://lh3.googleusercontent.com/QyubIhq0rUOF6qn7-Wz2_PELU2Q9wR1vBJYZzv_0wkgNuQWALFXML3q31TlPO1iJpPDD13_VFgFR2-KbQh5EznD1NSsgUMHqeh4";
        this.topImage = MenuUtils.getSectionPromoImgUrl(this.section);
      } else {
        this.categories = [];
      }
      if (this.categories) {
        this.translate.categories(this.categories);
        for (const cat of this.categories) {
          this.menuService.buildVisibleItems(cat.items);
          this.translate.items(cat.items);
        }
      }

      const nav = this.appStateService.navOnMenuPage(this.pageId!, this.appState, this.categories.length === 0);
      if (nav != null) {
        this.router.navigate(nav);
      }
    });

    // this.sub2 = this.translate.translationsReceivedSubject.subscribe(() => {
    //   console.log("MenuPageComponent translations received");
      //this.visibleSections = this.filterSections();
    // });
  }

  displayItem(item: MenuItem) {
    this.bottomSheetService.displayItem(item);
  }

  private filterCategories(categories: MenuCategory[]) {
    const filteredCategories = categories.map((category) => {
      const visibleItems = category.items.filter((item) => !item.mhide && item.class !== 'promo');
      if (visibleItems.length > 0) {
        return {
          ...category,
          items: visibleItems,
        };
      }
      return null;
    }).filter((category) => category !== null);

    return this.translate.categories(filteredCategories);
  }

  back() {
    this.router.navigate([this.appStateService.venueId, "menu", this.pageId]);
  }

  getPageName(pageId: string | null) {
    const prebookMenu = this.appState ? MenuUtils.prebookMenus(this.appState).find(menu => menu.id === pageId) : undefined;
    if (prebookMenu) {
      return prebookMenu.name;
    }
    const pageNames: Record<string, string> = {
      food: 'Mat',
      drinks: 'Dryck',
    };
    const name = pageNames[pageId??''];
    return this.translate.getString(name);
  }

  getString(s: string) {
    return this.translate.getString(s);
  }
}
